<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-freeze-columns`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M41.778 4C43.005 4 44 4.995 44 6.222v2.586l.02.02-.02.02V42a2 2 0 01-2 2H6.222A2.222 2.222 0 014 41.778V6.222C4 4.995 4.995 4 6.222 4h35.556zM18 25.848l-10 10V40h.591L18 30.59v-4.742zM40 22H24a2 2 0 00-2 2v16h18V22zM18 34.833L12.833 40H18v-5.167zM31.605 8h-4.999l.122.121L8 26.85v4.757l11.182-11.182c.35-.472.77-.891 1.242-1.242L31.605 8zm-9 0h-4.999l.122.121L8 17.848v4.757L22.605 8zM40 8h-4.394l.122.121L25.848 18h4.757L40 8.606V8zm0 4.848L34.848 18H40v-5.152zM13.606 8H8v5.606L13.606 8z"/></svg>
</template>
<script>

export default {
  name: 'IconFreezeColumns',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
